import { useEffect, useState } from "react";
import api, { fmtINR } from "@/lib/api";
import { Input } from "@/components/ui/input";

export default function Pharmacy() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/medicines", { params: { q } }).then((r) => setRows(r.data)); }, [q]);

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-end"><h1 className="font-display text-2xl font-semibold">Pharmacy</h1></div>
      <div className="bg-white border">
        <div className="p-3 border-b flex gap-2">
          <Input placeholder="Search medicine / generic..." value={q} onChange={(e) => setQ(e.target.value)} className="max-w-md h-9" data-testid="pharmacy-search" />
          <div className="ml-auto text-xs text-slate-500 self-center">{rows.length} medicines</div>
        </div>
        <table className="w-full text-sm">
          <thead><tr className="bg-slate-50 text-left"><th className="label-tiny p-2">Name</th><th className="label-tiny">Generic</th><th className="label-tiny">Category</th><th className="label-tiny">Batch</th><th className="label-tiny">Expiry</th><th className="label-tiny text-right">MRP</th><th className="label-tiny text-right">Stock</th></tr></thead>
          <tbody>
            {rows.map((m) => (
              <tr key={m.id} className="border-b">
                <td className="p-2 font-medium">{m.name}</td><td>{m.generic}</td><td>{m.category}</td>
                <td className="font-mono text-xs">{m.batch}</td><td className="font-mono text-xs">{m.expiry}</td>
                <td className="text-right font-mono">{fmtINR(m.selling_price)}</td>
                <td className={`text-right font-mono ${m.stock < m.reorder_level ? "text-red-700" : ""}`}>{m.stock}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
